import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';

const DATA = {
  hero: {
    label: 'Integrations',
    title: 'Seamlessly connect with your favorite tools',
    subtitle: 'CHIRE integrates with your existing ATS, calendar, and communication tools so hiring never skips a beat.',
    gradient: 'linear-gradient(150deg, #0076A3 0%, #0076A3 50%, #0076A3 100%)',
  },
  sections: [
    {
      label: 'ATS Integrations',
      title: 'Connect your applicant tracking system',
      features: [
        { icon: '🌿', title: 'Greenhouse', desc: 'Sync candidates, assessments, and interview results directly into your Greenhouse pipeline. Scores flow automatically.' },
        { icon: '📊', title: 'Lever', desc: 'Push CHIRE scores and reports into Lever candidate profiles. No copy-pasting between tools.' },
        { icon: '🔗', title: 'Ashby', desc: 'Full integration with Ashby\'s modern ATS. Assessment links, scores, and candidate data sync in real-time.' },
        { icon: '🏢', title: 'Workday', desc: 'Enterprise integration with Workday HCM. Available on the Enterprise plan.' },
        { icon: '☁️', title: 'Oracle', desc: 'Connect to Oracle Recruiting Cloud for enterprise-grade candidate management.' },
        { icon: '🔄', title: 'Custom API', desc: 'RESTful API for custom integrations. Webhooks for real-time events. Full documentation available.' },
      ],
      columns: 3,
    },
    {
      label: 'Calendar & Communication',
      title: 'Schedule and communicate without switching tools',
      features: [
        { icon: '📅', title: 'Google Calendar', desc: 'Sync interview schedules with Google Calendar. Candidates and interviewers get automatic invitations.' },
        { icon: '📆', title: 'Outlook Calendar', desc: 'Full Microsoft Outlook integration for enterprise teams. Meeting links auto-generated.' },
        { icon: '📧', title: 'Email Notifications', desc: 'Automated email notifications for assessment invitations, interview reminders, and status updates.' },
        { icon: '💬', title: 'Slack', desc: 'Get hiring updates in your Slack channels. New applications, completed assessments, and interview scores — in real-time.' },
      ],
      columns: 4,
    },
  ],
  testimonial: { quote: 'The Greenhouse integration was seamless. Assessment scores appear right in our candidate profiles — our hiring managers love it.', name: 'Tom H.', role: 'Recruiting Lead, DataScale' },
  cta: { title: 'Connect CHIRE to your workflow', desc: 'Set up integrations in minutes. Your existing tools, supercharged with AI-powered hiring.' },
};

export default function IntegrationsPage() { return <ProductPageTemplate data={DATA} />; }
